import Vue from 'vue';
import VueMask from 'v-mask';

import App from '@/main/App.vue';
import router from '@/main/router';
import store from '@/main/store';

import VueGtm from 'vue-gtm';
import { datadogRum } from '@datadog/browser-rum';
import VueDragscroll from 'vue-dragscroll';

import '@/shared/filters';
import '@/polyfills';
import '@/plugins/veevalidate';
import '@/plugins/vuetify/vuetify.scss';
import i18n from '@/plugins/i18n';
import vuetify from '@/plugins/vuetify/vuetify';

import '@/assets/scss/main.scss';

Vue.config.productionTip = false;

Vue.use(VueDragscroll);
Vue.use(VueMask);

if (process.env.VUE_APP_GTM_ENABLED === 'true') {
  (window as any)._etmc = []; // workaround to fix 'ReferenceError: _etmc is not defined'

  Vue.use(VueGtm, {
    id: 'GTM-MRRZPTR',
    debug: process.env.NODE_ENV === 'development',
    vueRouter: router,
  });
}

if (process.env.VUE_APP_DATADOG_ENABLED === 'true') {
  datadogRum.init({
    applicationId: process.env.VUE_APP_DATADOG_ID as string,
    clientToken: process.env.VUE_APP_DATADOG_TOKEN as string,
    site: process.env.VUE_APP_DATADOG_SITE as string,
    service: 'ecommerce-checkout',
    env: process.env.VUE_APP_ENV,
    sampleRate: 100,
    trackInteractions: true,
  });
}

new Vue({
  i18n,
  store,
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
